module.exports = __webpack_public_path__ + "media/customizations/parkvueontheplatte/back-d03cc9482f0f68b79f8a24913cee667a.jpg";